import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';
import { postRecessCancelAction } from '../sagas/recess/recessCancelSaga';

// 休会取消を取得実行します。
const recessCancelService = (action: postRecessCancelAction): any => {
  const postData = {
    member_id: action.memberNo,
    shop_id: action.shopId,
  };

  return {
    postRecessCancel: () => apiClient.post(`${API_BASE_ADDRESS}/mypage/member/recess-cancel`, postData),
  };
};

export default recessCancelService;
